import { render, staticRenderFns } from "./RemSettingTab.vue?vue&type=template&id=ffe9527a&"
import script from "./RemSettingTab.vue?vue&type=script&lang=js&"
export * from "./RemSettingTab.vue?vue&type=script&lang=js&"
import style0 from "./RemSettingTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports